import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3954ed95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings-title" }
const _hoisted_3 = { class: "settings-title-name" }
const _hoisted_4 = { class: "settings-info" }
const _hoisted_5 = { class: "settings-info-title" }
const _hoisted_6 = { class: "settings-info-title" }
const _hoisted_7 = { class: "settings-info-title" }
const _hoisted_8 = { class: "settings-info-title" }
const _hoisted_9 = { class: "settings-info-title" }
const _hoisted_10 = { class: "settings-content-first" }
const _hoisted_11 = { class: "settings-item" }
const _hoisted_12 = { class: "item-title" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "settings-item" }
const _hoisted_16 = { class: "item-title" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "settings-item" }
const _hoisted_20 = { class: "item-title" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "settings-content-second" }
const _hoisted_24 = { class: "settings-item" }
const _hoisted_25 = { class: "item-title" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "settings-item" }
const _hoisted_29 = { class: "item-title" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "settings-item" }
const _hoisted_33 = { class: "item-title" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "settings-content-third" }
const _hoisted_37 = { class: "settings-item" }
const _hoisted_38 = { class: "item-title" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "settings-item" }
const _hoisted_42 = { class: "item-title" }
const _hoisted_43 = ["placeholder"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "settings-item" }
const _hoisted_46 = { class: "item-title" }
const _hoisted_47 = ["placeholder"]
const _hoisted_48 = ["disabled"]

import { Device } from "@/interface/device";
import { configSettingAxios } from "@/service/config.service";
import { userUseStore } from "@/store/user";
import { ref, watchEffect, computed } from "vue";
import { useRoute } from "vue-router";
import Loading from "vue3-loading-overlay";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = userUseStore();
const route = useRoute();

const configState = ref({
  mac: String(route.query.mac),
  group: "None",
  userName: "None",
  siteName: "None",
  lon: "None",
  lat: "None",
});

const settingsData = ref({
  SDT: 0, // SD
  SDCT: 0, // SDC
  STO: 0, // TO
  SO1: 0, // O1T
  SO2: 0, // O2T
  SA1: 0, // A1T
  SA2: 0, // A2T
  SDC: 0, // DTT
  SCT: 0, // SCT
});

const settings = ref({
  SDT: { command: "SDT", value: "" },
  SDCT: { command: "SDCT", value: "" },
  STO: { command: "STO", value: "" },
  SO1: { command: "SO1", value: "" },
  SO2: { command: "SO2", value: "" },
  SA1: { command: "SA1", value: "" },
  SA2: { command: "SA2", value: "" },
  SDC: { command: "SDC", value: "" },
  SCT: { command: "SCT", value: "" },
});

const findMac = computed(() => {
  if (userStore.realTimeData[0]) {
    const idx = userStore.findMac(String(route.query.mac));
    console.log(`finemac : ${idx}`);
    return idx;
  } else {
    return 0;
  }
});

const selectMachine = async () => {
  const findMac = userStore.deviceList.find((val: Device) => {
    return val.mac_addr === configState.value.mac;
  });
  if (findMac) {
    configState.value.mac = findMac.mac_addr;
    configState.value.group = findMac.group;
    configState.value.userName = findMac.user_name;
    configState.value.siteName = findMac.site_name;
    configState.value.lon = findMac.lon;
    configState.value.lat = findMac.lat;
  }
};

const settingClick = async (command: string, value: string) => {
  userStore.loadingChange(0);
  if (value) {
    const o = confirm(`setting : Command : ${command} , Value : ${value} ?`);
    if (o) {
      await configSettingAxios(configState.value.mac, command, value);
      if (command === "SDT") {
        settings.value.SDT.value = "";
      }
      if (command === "SDCT") {
        settings.value.SDCT.value = "";
      }
      if (command === "STO") {
        settings.value.STO.value = "";
      }
      if (command === "SO1") {
        settings.value.SO1.value = "";
      }
      if (command === "SO2") {
        settings.value.SO2.value = "";
      }
      if (command === "SA1") {
        settings.value.SA1.value = "";
      }
      if (command === "SA2") {
        settings.value.SA2.value = "";
      }
      if (command === "SDC") {
        settings.value.SDC.value = "";
      }
      if (command === "SCT") {
        settings.value.SCT.value = "";
      }
      userStore.loadingChange(1);
    } else {
      userStore.loadingChange(1);
      return;
    }
  }
};

watchEffect(async () => {
  if (configState.value.mac) {
    await selectMachine();
  }
  if (userStore.realTimeData[0]) {
    settingsData.value.SDT =
      userStore.realTimeData[findMac.value].setup_dry_time;
    settingsData.value.SDCT =
      userStore.realTimeData[findMac.value].setup_discharge_time;
    settingsData.value.STO =
      userStore.realTimeData[
        findMac.value
      ].tank_over_heating_detect_temperature;
    settingsData.value.SO1 =
      userStore.realTimeData[findMac.value].oil_heater_1_target_temperature;
    settingsData.value.SO2 =
      userStore.realTimeData[findMac.value].oil_heater_2_target_temperature;
    settingsData.value.SA1 =
      userStore.realTimeData[findMac.value].air_heater_1_target_temperature;
    settingsData.value.SA2 =
      userStore.realTimeData[findMac.value].air_heater_2_target_temperature;
    settingsData.value.SDC =
      userStore.realTimeData[findMac.value].discharge_heater_target_temperature;
    settingsData.value.SCT =
      userStore.realTimeData[findMac.value].setup_cooling_time;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loading), {
      active: _unref(userStore).isLoading,
      "is-full-page": false,
      "background-color": "#2b323a",
      color: "#8c98a5",
      opacity: 0.8
    }, null, 8, ["active", "opacity"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("settings_machine_info")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("site")) + " : " + _toDisplayString(configState.value.siteName), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("group")) + " : " + _toDisplayString(configState.value.group), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("user")) + " : " + _toDisplayString(configState.value.userName), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("lat")) + " : " + _toDisplayString(configState.value.lat), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("lon")) + " : " + _toDisplayString(configState.value.lon), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_dry_run_time")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Dry Run Time : ${settingsData.value.SDT}`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.SDT.value) = $event))
            }, null, 8, _hoisted_13), [
              [_vModelText, settings.value.SDT.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SDT.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (settingClick(settings.value.SDT.command, settings.value.SDT.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_14)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_discharge_run_time")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Discharge Run Time : ${settingsData.value.SDCT}`,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.SDCT.value) = $event))
            }, null, 8, _hoisted_17), [
              [_vModelText, settings.value.SDCT.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SDCT.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (
                  settingClick(settings.value.SDCT.command, settings.value.SDCT.value)
                ))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_18)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_cooling_time")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Cooling Time : ${settingsData.value.SCT}`,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settings.value.SCT.value) = $event))
            }, null, 8, _hoisted_21), [
              [_vModelText, settings.value.SCT.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SCT.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (settingClick(settings.value.SCT.command, settings.value.SCT.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_22)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_oil_heater_1_target_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Oil Heater 1 Target Temperature : ${settingsData.value.SO1}`,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((settings.value.SO1.value) = $event))
            }, null, 8, _hoisted_26), [
              [_vModelText, settings.value.SO1.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SO1.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (settingClick(settings.value.SO1.command, settings.value.SO1.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_27)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_oil_heater_2_target_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Oil Heater 2 Target Temperature : ${settingsData.value.SO2}`,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((settings.value.SO2.value) = $event))
            }, null, 8, _hoisted_30), [
              [_vModelText, settings.value.SO2.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SO2.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (settingClick(settings.value.SO2.command, settings.value.SO2.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_31)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_tank_over_heating_detect_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Tank Over Heating Detect Temperature : ${settingsData.value.STO}`,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((settings.value.STO.value) = $event))
            }, null, 8, _hoisted_34), [
              [_vModelText, settings.value.STO.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.STO.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (settingClick(settings.value.STO.command, settings.value.STO.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_35)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_air_heater_1_target_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Air Heater 1 Target Temperature : ${settingsData.value.SA1}`,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((settings.value.SA1.value) = $event))
            }, null, 8, _hoisted_39), [
              [_vModelText, settings.value.SA1.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SA1.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (settingClick(settings.value.SA1.command, settings.value.SA1.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_40)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_air_heater_2_target_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Air Heater 2 Target Temperature : ${settingsData.value.SA2}`,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((settings.value.SA2.value) = $event))
            }, null, 8, _hoisted_43), [
              [_vModelText, settings.value.SA2.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SA2.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (settingClick(settings.value.SA2.command, settings.value.SA2.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_44)
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("set_discharge_heater_target_temperature")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("form", {
            onSubmit: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: `Set Discharge Heater Target Temperature : ${settingsData.value.SDC}`,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((settings.value.SDC.value) = $event))
            }, null, 8, _hoisted_47), [
              [_vModelText, settings.value.SDC.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                disabled: settings.value.SDC.value === '' || configState.value.mac === '',
                class: "btn settings-btn",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (settingClick(settings.value.SDC.command, settings.value.SDC.value)))
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_48)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})